import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Supplier from "../../models/supplier";

const RECORS_PER_SEARCH = 20;

type SupplierSelectProps = {
  value: Supplier | null;
  onChange: (_: Supplier | null) => void;
};

const SupplierSelect: React.FC<SupplierSelectProps> = ({ value, onChange }) => {
  const taxPayerId = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (Supplier | { options: Supplier[]; label?: string })[]
  ): Promise<
    Response<Supplier, { options: Supplier[]; label?: string }, any>
  > => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("tax_payer_id", taxPayerId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    const dataPaginated = await getList<Supplier>(
      "/suppliers/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Supplier[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione un Proveedor"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Supplier) =>
        `${option.fantasyName} - ${option.ruc}`
      }
      getOptionValue={(option: Supplier) => `${option.id}`}
      value={value}
      isClearable
    />
  );
};

export default SupplierSelect;
